function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
const CheckRadioField = ({
  check,
  onChange,
  options,
  readOnly,
  ...rest
}) => {
  const {
    value,
    id,
    isInvalid = false
  } = check;
  React.useEffect(() => {
    if (!readOnly) {
      onChange(value);
    }
  }, []);
  const handleChange = value => {
    const newValue = value;
    onChange(newValue);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioGroup, _extends({
    column: true,
    id: id,
    name: "radioptions",
    value: value ? value : "",
    helperText: isInvalid ? "Please select one option" : null
  }, rest), options.length > 0 && options.map((option, index) => {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: index,
      value: option,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "secondary",
        id: "optionRadioButton"
      }),
      label: /*#__PURE__*/React.createElement(Typography, null, option),
      disabled: readOnly,
      onChange: event => handleChange(event.target.value)
    });
  })));
};
export default CheckRadioField;
CheckRadioField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  options: PropTypes.array
};